import { vappContainer, VApplication } from '../../../../../application';
import { logger as log } from '@common/logger';
import { AdminPageService } from '@/pages/Admin/services';

const MODULE_NAME = 'profile.machines.states.reinviteUser';

const getSrv = () => {
  return vappContainer.get<AdminPageService>(AdminPageService.displayName);
};

export const removeAccess = async (context: any, event: any) => {
  const currentState = 'REMOVE_ACCESS';
  const method = 'reInvite';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent?.removeAccess(event?.payload);
      if (content) {
        return resolve({
          key: 'REMOVE_ACCESS_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Reset password failed';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'REMOVE_ACCESS_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'REMOVE_ACCESS_FAILED',
        value: _msg,
      });
    }
  });
};
